import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { AfterViewInit, Directive, HostListener, OnInit, Renderer2, ViewContainerRef } from '@angular/core';

/**
 * The TcwSidebarStylesDirective modifies the styles and behavior of the TWC sidebar component to suit our needs
 */
@Directive({
    selector: '[cwTcwSidebarStyles]',
    standalone: false,
})
export class TcwSidebarStylesDirective implements OnInit, AfterViewInit {
    private twcSidebar: HTMLElement | null = null;
    private twcSidebarContent: HTMLElement | null = null;
    private twcHeader: HTMLElement | null = null;
    private twcExpandButton: HTMLElement | null = null;
    private sidebarItems: HTMLElement[] | null = null;
    private expandedSidebar = false;

    constructor(
        private renderer: Renderer2,
        private viewContainer: ViewContainerRef,
        public breakpointObserver: BreakpointObserver
    ) {}

    ngOnInit(): void {
        this.twcSidebar = this.viewContainer.element.nativeElement;
        this.twcSidebarContent = this.viewContainer.element.nativeElement.querySelector('div.twc-sidebar-content');
        this.twcHeader = this.viewContainer.element.nativeElement.querySelector('div.twc-sidebar-header');
        this.twcExpandButton = this.viewContainer.element.nativeElement.querySelector('button.twc-sidebar-expand');

        this.setSidebarBackgroundColor();
        this.maintainSidebarAspectAlways();
    }

    ngAfterViewInit(): void {
        this.sidebarItems = this.viewContainer.element.nativeElement.querySelectorAll('twc-sidebar-item');

        this.expandButtonsStyle();
        this.removeChevronOnCollapseSidebar();
    }

    @HostListener('click', ['$event.target'])
    overwriteSidebarCollapseBehavior(target: HTMLElement): any {
        const element = target.closest('button');

        if (!element?.classList.contains('twc-sidebar-collapse') && !element?.classList.contains('twc-sidebar-expand')) {
            if (this.expandedSidebar) {
                this.renderer.addClass(this.twcSidebar, 'twc-expanded');
            }
            return;
        }

        this.expandCollapseListener(element);
    }

    expandCollapseListener(element: HTMLElement): void {
        if (element.classList.contains('twc-sidebar-collapse')) {
            this.renderer.removeClass(this.twcSidebar, 'twc-expanded');
            this.renderer.setStyle(this.twcExpandButton, 'display', 'inline-block');
            this.expandedSidebar = false;
            this.removeChevronOnCollapseSidebar();
        } else {
            this.renderer.addClass(this.twcSidebar, 'twc-expanded');
            this.renderer.setStyle(this.twcExpandButton, 'display', 'none');
            this.expandedSidebar = true;
            this.addChevronOnExpandSidebar();
        }
    }

    private expandButtonsStyle(): void {
        this.renderer.setStyle(this.twcExpandButton, 'display', 'flex');
    }

    private setSidebarBackgroundColor(): void {
        this.renderer.setStyle(this.twcSidebarContent, 'background-color', 'var(--twc-dark-gray)');
        this.renderer.setStyle(this.twcSidebarContent, 'top', '0');
    }

    private maintainSidebarAspectAlways(): void {
        this.breakpointObserver.observe(['(max-width: 639px)']).subscribe((state: BreakpointState) => {
            if (state.matches) {
                this.renderer.setStyle(this.twcSidebar, 'min-width', '3.5rem');

                this.renderer.setStyle(this.twcSidebarContent, 'min-width', '3.5rem');
                this.renderer.setStyle(this.twcSidebarContent, 'left', '0');

                this.renderer.setStyle(this.twcHeader, 'height', '3.5rem');
                this.renderer.setStyle(this.twcHeader, 'padding', '0.375rem');
            }
        });
    }

    private addChevronOnExpandSidebar(): void {
        this.sidebarItems?.forEach((item: HTMLElement) => {
            const chevronItem = item.querySelector('twc-icon.sidebar-item-chevron');
            if (chevronItem) {
                this.renderer.setStyle(chevronItem, 'visibility', 'visible');
            }
        });
    }

    private removeChevronOnCollapseSidebar(): void {
        this.sidebarItems?.forEach((item: HTMLElement) => {
            const chevronItem = item.querySelector('twc-icon.sidebar-item-chevron');
            if (chevronItem) {
                this.renderer.setStyle(chevronItem, 'visibility', 'hidden');
            }
        });
    }
}
